import $ from 'jquery';
import "../custom-vendor/slick-carousel/slick/slick";

export class AffiliatesSlideshow {
  constructor($el, conf) {
    this.$el = $el;
    let slickConf = Object.assign(this.slickDefaults(), conf);

    // bind event prior to slick init
    this.bindEvents();
    this.$el.slick(slickConf);
  }

  bindEvents() {
    // bind an event on the arrows to de-focus them when
    // you mouse out, so the focus state doesn't get stuck
    this.$el.on("mouseleave", ".slick-next, .slick-prev", event => {
      event.currentTarget.blur();
    });

    this.$el.on("beforeChange", function(event, slick, currentSlide, nextSlide){
      $(window).trigger( "slideChange" );
    });
  }

  /* See http://kenwheeler.github.io/slick/ for Slick Slider options */
  slickDefaults() {
    return {
      adaptiveHeight: true,
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      appendArrows: this.$el.siblings(".js-slideshow__nav"),
      prevArrow: `
        <button type="button" class="slick-prev" tabindex="0" aria-label="go back one slide"></button>`,
      nextArrow: `
        <button type="button" class="slick-next" tabindex="0" aria-label="advance one slide"></button>`,
      responsive: [
        {
          breakpoint: 880,
          settings: {
            adaptiveHeight: true,
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendArrows: this.$el.siblings(".js-slideshow__nav"),
            prevArrow: `
              <button type="button" class="slick-prev" tabindex="0" aria-label="go back one slide"></button>`,
            nextArrow: `
              <button type="button" class="slick-next" tabindex="0" aria-label="advance one slide"></button>`
          }
        }
      ]
    };
  }
}
